module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.c586756.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/fonts/Roboto-Regular.woff
// module id = V0sW
// module chunks = 0